var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2a26d85016bb99a8af753d0cc47e936596fab224"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react-native-jobs@jimmy-cook"]={id:"2a26d85016bb99a8af753d0cc47e936596fab224"};
      